interface ishareoptions {
    text: string;
    url: string;
    title: string;
    clipboardtext: string;
}

function checkIfCustomConfirmationPage(customName: string) {
    return window.location.href.toLowerCase().includes(customName);
}

const getShareOptions = (): ishareoptions => {
    const isMarketplace: boolean = checkIfCustomConfirmationPage("marketplace");

    const isCaron: boolean = checkIfCustomConfirmationPage("caron");

    const isRewarded: boolean = checkIfCustomConfirmationPage("rewarded");

    if (isMarketplace) {
        return {
            text: "Ordering ahead using the REWARDed app by Lori's was a breeze!",
            url: "https://hospitalgiftshop.com/loris-marketplace-locations",
            title: "Check out the REWARDed by Lori's App!",
            clipboardtext:
                "Check out the REWARDed by Lori's App! - https://hospitalgiftshop.com/loris-marketplace-locations",
        };
    }

    if (isCaron) {
        return {
            text: "Caron Treatment Center Logo Wear is now available at HospitalGiftShop.com!",
            url: "https://hospitalgiftshop.com/caron-treatment-center-gift-shop",
            title: "Caron Treatment Center Logo Wear",
            clipboardtext:
                "Caron Treatment Center Logo Wear is now available at HospitalGiftShop.com! (https://hospitalgiftshop.com/caron-treatment-center-gift-shop)",
        };
    }

    if (isRewarded) {
        return {
            text: "Lori's REWARDed Deals are now available at HospitalGiftShop.com!",
            url: "https://www.hospitalgiftshop.com/SearchResult.aspx?CategoryId=1716&hid=98630300",
            title: "Lori's REWARDed Deals",
            clipboardtext:
                "Lori's REWARDed Deals are now available at HospitalGiftShop.com! (https://www.hospitalgiftshop.com/SearchResult.aspx?CategoryId=1716&hid=98630300)",
        };
    }

    return {
        text: "At HospitalGiftShop.com, we understand that being away from your loved ones during difficult times can be tough. That's why we're here to help you stay connected, even if you can't be there in person. Support from friends and family can make a world of difference for a person recovering in the hospital. Share HospitalGiftShop.com to start a gift train and extend support for your loved one today.",
        url: "https://hospitalgiftshop.com",
        title: "HospitalGiftShop.com - Start a Gift Train!",
        clipboardtext:
            "All aboard the gift train! Did you know that receiving a gift in the hospital may give the recipient a boost in their recovery? Join me in providing love and support by sending a gift from HospitalGiftShop.com (https://hospitalgiftshop.com)",
    };
};

const share = (): void => {
    const options = getShareOptions();

    if (navigator.share) {
        navigator.share(options);
    } else {
        navigator.clipboard.writeText(options.clipboardtext);
        showToast();
    }
};

const shareButton: HTMLButtonElement = document.querySelector(
    ".share button"
) as HTMLButtonElement;
if (shareButton) {
    shareButton.addEventListener("click", share);

    import("./analytics/analytics-events").then(({ trackButtonClickEvent }) => {
        trackButtonClickEvent(shareButton);
    });
}

function createToastContainer(): HTMLDivElement {
    const toastContainer = document.createElement("div");
    toastContainer.classList.add("toastContainer");
    return toastContainer;
}
function showToast(): void {
    let toastContainer: HTMLDivElement = document.querySelector(
        ".toastContainer"
    ) as HTMLDivElement;
    if (!toastContainer) {
        toastContainer = createToastContainer();
        document.body.appendChild(toastContainer);
    }

    const toast: HTMLDivElement = document.createElement("div");
    toast.classList.add("toast");
    toast.innerHTML = `<p>A message has been copied to your clipboard.</p><p>Simply paste the message into your favorite messaging or social media app to start a Gift Train!</p>`;
    toastContainer.appendChild(toast);

    setTimeout(() => {
        toast.remove();
    }, 10000);
}

export {};
